
export class User {

  id: string = ""

  firstName: string = ""
  lastName: string = ""

  username: string = ""; // the login email 
  emails: string[] = [];
  organisation: string = "";

  constructor(init?: Partial<User>) {
      Object.assign(this, init);
  }
}

